module.exports = __webpack_public_path__ + "img/data_privacy_icon.4c5e40e4.svg";